import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import s from './ConnectionTestResult.module.css';
export function ConnectionTestStrip({ pending, result, }) {
    if (pending) {
        return (_jsxs("div", { className: `${s.strip} ${s.pending}`, children: [_jsx("span", { className: s.mark, children: "\u2026" }), _jsx("div", { className: s.body, children: "Testing connection\u2026" })] }));
    }
    if (!result)
        return null;
    if (!result.ok) {
        return (_jsxs("div", { className: `${s.strip} ${s.fail}`, children: [_jsx("span", { className: s.mark, children: "\u2717" }), _jsxs("div", { className: s.body, children: [_jsxs("div", { children: ["Connection failed \u00B7 ", result.latency_ms, "ms"] }), result.error && _jsx("div", { className: s.detail, children: result.error })] })] }));
    }
    const bits = [`${result.latency_ms}ms`];
    if (result.server_version)
        bits.push(`PostgreSQL ${result.server_version}`);
    if (result.can_head !== undefined && result.can_head !== null) {
        bits.push(result.can_write ? 'read + write' : 'read only');
    }
    return (_jsxs("div", { className: `${s.strip} ${result.warning ? s.warn : s.ok}`, children: [_jsx("span", { className: s.mark, children: result.warning ? '!' : '✓' }), _jsxs("div", { className: s.body, children: [_jsxs("div", { children: ["Connected \u00B7 ", bits.join(' · ')] }), result.warning && _jsx("div", { className: s.detail, children: result.warning })] })] }));
}
